import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7e3d9175")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_quote_box = _resolveComponent("quote-box")
  const _component_buy_button = _resolveComponent("buy-button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_quote_box, {
      body: "What a wonderful book! We gave to a lovely, and lively, little girl on Christmas Eve. She sat still on her grandma's lap and insisted that Grandma read it over and over. She simply loved it!",
      author: "Stephanie"
    }),
    _createVNode(_component_quote_box, {
      body: "I've purchased two of these books and given them to young children as gifts. They were in love with the book. I was sent videos of the kids with the books and they are just so sweet. Wonderfully written and illustrated.",
      author: "Mark"
    }),
    _createVNode(_component_quote_box, {
      body: "I gave this book to the children of 3 of my friends and they all said it was the \"best gift ever!\" Parents loved it too! and said the children keep reading it over and over!",
      author: "Susan"
    }),
    _createVNode(_component_buy_button, { class: "p-2" })
  ]))
})